import { ReactNode } from 'react';

import SubTitle from 'components/SubTitle';

import * as Styled from './ScoreCard.styles';

interface ScoreCardProps {
  label: string;
  children: ReactNode;
}

const ScoreCard = ({ label, children }: ScoreCardProps) => (
  <Styled.Card
    title={<SubTitle noMargin>{label}</SubTitle>}
    bodyStyle={{
      padding: '8px',
    }}
  >
    {children}
  </Styled.Card>
);

export default ScoreCard;
